"use client";

import { createContext, useContext, useState } from "react";
import RequestModal from "./RequestModal";

type Ctx = {
  open: () => void;
};

const ContactCtx = createContext<Ctx>({ open: () => {} });

export function useContactModal() {
  return useContext(ContactCtx);
}

export type LeadRouting = {
  email?: string;
  telegramChatId?: string;
  hashtag?: string;
  emailFrom?: string;
};

/**
 * Провайдер модалки «Получить предложение».
 *
 * `cityNames` — список городов для селекта (из admin).
 * `routing` — куда доставлять заявку (email/telegram/hashtag/from) — из
 * admin-настроек «Общие». Прокидывается в RequestModal → /api/lead.
 */
export default function ContactProvider({
  children,
  cityNames,
  routing,
}: {
  children: React.ReactNode;
  cityNames?: string[];
  routing?: LeadRouting;
}) {
  const [open, setOpen] = useState(false);
  return (
    <ContactCtx.Provider value={{ open: () => setOpen(true) }}>
      {children}
      <RequestModal
        open={open}
        onClose={() => setOpen(false)}
        cityNames={cityNames}
        routing={routing}
      />
    </ContactCtx.Provider>
  );
}
